import { AuthenticationStore } from "./global/AuthenticationStore/AuthenticationStore";
import { SysMenuStore } from "./global/SysMenuStore/SysMenuStore";
import { SysMsgStore } from "./global/SysMsgStore/SysMsgStore";
import { ServerRouterStore } from "./global/ServerRouterStore/ServerRouterStore";
import { SysParamsStore } from "./global/SysParamsStore/SysParamsStore";
import { IntAssessHdrStore } from "./global/IntAssessHdrStore/IntAssessHdrStore";
import Vue from "vue";
import Vuex from "vuex";
import { LoaderStore } from "./global/LoaderStore/LoaderStore";
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    username: "",
    password: "",
    isRememberMe: false,
    Lang: "EN"
  },

  plugins: [
    createPersistedState({
      paths: [
        "LoaderStore",
        "SysMsgStore",
        "SysMenuStore",
        "AuthenticationStore",
        "ServerRouterStore",
        "SysParamsStore",
        "IntAssessHdrStore"
      ] //Stores that will kept in location storage after F5 refresh
    })
  ],
  modules: {
    LoaderStore,
    SysMsgStore,
    SysMenuStore,
    AuthenticationStore,
    ServerRouterStore,
    SysParamsStore,
    IntAssessHdrStore
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js